import { render } from "./TimeTableTable.vue?vue&type=template&id=621fed26"
import script from "./TimeTableTable.vue?vue&type=script&lang=ts"
export * from "./TimeTableTable.vue?vue&type=script&lang=ts"
script.render = render

export default script